import { z } from "zod";

const citySchema = z.object({
  value: z.string(),
  label: z.string(),
  cityName: z.string().optional(),
});

export const createFlightSearchSchema = (t) =>
  z
    .object({
      departureCity: citySchema.nullable().refine((city) => city !== null, {
        message: t("searchErrorsDepartureRequired"),
      }),
      returnCity: citySchema.nullable().refine((city) => city !== null, {
        message: t("searchErrorsReturnRequired"),
      }),
      returnDate: z.date().optional(),
      isRoundTrip: z.boolean(),
    })
    .refine(
      (data) => {
        if (data.departureCity && data.returnCity) {
          const isSameSelection =
            data.departureCity.value === data.returnCity.value;
          const departureCityName = data.departureCity.cityName
            ?.trim()
            .toLocaleLowerCase("tr-TR");
          const returnCityName = data.returnCity.cityName
            ?.trim()
            .toLocaleLowerCase("tr-TR");
          const isSameCityName =
            Boolean(departureCityName) &&
            Boolean(returnCityName) &&
            departureCityName === returnCityName;

          return !isSameSelection && !isSameCityName;
        }
        return true;
      },
      {
        message: t("searchErrorsSameDepartureReturn"),
        path: ["returnCity"],
      },
    )
    .refine(
      (data) => {
        if (data.isRoundTrip) {
          return data.returnDate !== null && data.returnDate !== undefined;
        }
        return true;
      },
      {
        message: t("searchErrorsReturnDateRequired"),
        path: ["returnDate"],
      },
    )
    .refine(
      (data) => {
        if (data.returnDate) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return data.returnDate >= today;
        }
        return true;
      },
      {
        message: t("searchErrorsReturnDatePast"),
        path: ["returnDate"],
      },
    );

export default createFlightSearchSchema;
